var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('div', {
    staticClass: "visual poppins mb-lg-120"
  }, [_c('div', {
    staticClass: "visual-inner"
  }, [_c('v-container', [_c('div', {
    staticClass: "visual-contents"
  }, [_c('img', {
    attrs: {
      "src": "/images/ci-light.svg",
      "alt": ""
    }
  }), _c('p', [_vm._v("INTEGRATE SYSTEM TECHNOLOGY")])]), _c('div', {
    staticClass: "scr-wrap d-none d-lg-flex"
  }, [_c('p', [_vm._v("scroll down")]), _c('div', {
    staticClass: "scr"
  })])])], 1), _c('div', {
    staticClass: "visual-vod"
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "muted": "",
      "autoplay": "",
      "loop": "",
      "poster": "/images/main/visual.png"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "/res/main/visual.mp4",
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])])])]), _c('section', {
    staticClass: "main-section main-section1 pt-80 pt-md-100 pt-lg-140 pb-100 pb-md-120 pb-lg-160 border-bottom"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title pt-lg-50 mb-32 mb-lg-130"
  }, [_c('h2', [_vm._v("PRODUCT")])]), _c('v-row', {
    staticClass: "mx-xl-n64 my-xl-n30 s1-item-group"
  }, [_c('v-col', {
    staticClass: "px-xl-64 py-xl-30",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('a', {
    staticClass: "s1-item s1-item2 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60",
    attrs: {
      "href": "/products/CMP"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/prd-img2.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "s1-txt"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey"
  }, [_vm._v("Machining Products")]), _c('h4', {
    staticClass: "poppins tit font-weight-medium"
  }, [_vm._v("CMP Retainer - Ring")])]), _c('button', {
    staticClass: "arrow-button white round"
  }, [_c('img', {
    staticClass: "d-block arrow-show",
    attrs: {
      "src": "/images/common/arrow.svg",
      "alt": ""
    }
  })])]), _c('a', {
    staticClass: "s1-item s1-item4 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60",
    attrs: {
      "href": "/products/metal"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/prd-img4.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "s1-txt"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey"
  }, [_vm._v("Machining Products")]), _c('h4', {
    staticClass: "poppins tit font-weight-medium"
  }, [_vm._v("Metal")])]), _c('button', {
    staticClass: "arrow-button white round"
  }, [_c('img', {
    staticClass: "d-block arrow-show",
    attrs: {
      "src": "/images/common/arrow.svg",
      "alt": ""
    }
  })])]), _c('a', {
    staticClass: "s1-item s1-item6 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60",
    attrs: {
      "href": "/products/engineering"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/prd-img6.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "s1-txt"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey"
  }, [_vm._v("Machining Products")]), _c('h4', {
    staticClass: "poppins tit font-weight-medium"
  }, [_vm._v(" Engineering "), _c('br', {
    staticClass: "pc"
  }), _vm._v(" Plastic & Rubber ")])]), _c('button', {
    staticClass: "arrow-button white round"
  }, [_c('img', {
    staticClass: "d-block arrow-show",
    attrs: {
      "src": "/images/common/arrow.svg",
      "alt": ""
    }
  })])]), _c('a', {
    staticClass: "s1-item s1-item7 w-100 arrow-button-wrap",
    attrs: {
      "href": "/distributor/tdk"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/prd-img7.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "s1-txt"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey"
  }, [_vm._v("Distributor in Korea")]), _c('h4', {
    staticClass: "poppins tit font-weight-medium"
  }, [_vm._v("TDK Power Supply")])]), _c('button', {
    staticClass: "arrow-button white round"
  }, [_c('img', {
    staticClass: "d-block arrow-show",
    attrs: {
      "src": "/images/common/arrow.svg",
      "alt": ""
    }
  })])])]), _c('v-col', {
    staticClass: "px-xl-64 py-xl-30",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('a', {
    staticClass: "s1-item s1-item8 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60",
    attrs: {
      "href": "/distributor/kalrez"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/prd-img8.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "s1-txt"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey"
  }, [_vm._v("Distributor in Korea")]), _c('v-img', {
    staticClass: "dupont dupont--kalrez",
    attrs: {
      "src": "/images/logos/kalrez.png",
      "alt": "Kalrez"
    }
  })], 1), _c('button', {
    staticClass: "arrow-button white round"
  }, [_c('img', {
    staticClass: "d-block arrow-show",
    attrs: {
      "src": "/images/common/arrow.svg",
      "alt": ""
    }
  })])]), _c('a', {
    staticClass: "s1-item s1-item1 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60",
    attrs: {
      "href": "/distributor/dupont"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/prd-img1.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "s1-txt"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey"
  }, [_vm._v("Distributor in Korea")]), _c('v-img', {
    staticClass: "dupont dupont--vespel",
    attrs: {
      "src": "/images/logos/vespel.png",
      "alt": "Vespel"
    }
  })], 1), _c('button', {
    staticClass: "arrow-button white round"
  }, [_c('img', {
    staticClass: "d-block arrow-show",
    attrs: {
      "src": "/images/common/arrow.svg",
      "alt": ""
    }
  })])]), _c('a', {
    staticClass: "s1-item s1-item3 w-100 arrow-button-wrap mb-12 mb-lg-28 mb-xl-60",
    attrs: {
      "href": "/distributor/endo"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/prd-img3.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "s1-txt"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey"
  }, [_vm._v("Distributor in Korea")]), _c('h4', {
    staticClass: "poppins tit font-weight-medium"
  }, [_vm._v("ENDO Metal-Sleeve")])]), _c('button', {
    staticClass: "arrow-button white round"
  }, [_c('img', {
    staticClass: "d-block arrow-show",
    attrs: {
      "src": "/images/common/arrow.svg",
      "alt": ""
    }
  })])]), _c('a', {
    staticClass: "s1-item s1-item5 w-100 arrow-button-wrap",
    attrs: {
      "href": "/distributor/oring"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/prd-img5.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "s1-txt"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 mb-4 mb-lg-8 color-grey"
  }, [_vm._v("Distributor in Korea")]), _c('h4', {
    staticClass: "poppins tit font-weight-medium"
  }, [_vm._v("Mitsubishi O-Ring")])]), _c('button', {
    staticClass: "arrow-button white round"
  }, [_c('img', {
    staticClass: "d-block arrow-show",
    attrs: {
      "src": "/images/common/arrow.svg",
      "alt": ""
    }
  })])])])], 1)], 1)], 1), _c('section', {
    staticClass: "main-section main-section2 py-100 py-md-120 py-lg-160"
  }, [_c('v-container', {
    attrs: {
      "lg": ""
    }
  }, [_c('div', {
    staticClass: "section-title text-center mb-32 mb-lg-50"
  }, [_c('h2', [_vm._v("What We Do")])]), _c('div', {
    staticClass: "bg-grey pa-30 py-md-50 pt-lg-160 pb-lg-110 mb-32 mb-lg-50"
  }, [_c('img', {
    staticClass: "d-none d-md-block mx-auto",
    attrs: {
      "src": "/images/main/s2-img.png",
      "alt": ""
    }
  }), _c('img', {
    staticClass: "d-block d-md-none mx-auto",
    attrs: {
      "src": "/images/main/s2-img-mo.png",
      "alt": ""
    }
  })]), _c('v-tabs', {
    staticClass: "mb-18 mb-lg-30 poppins",
    attrs: {
      "centered": "",
      "center-active": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v(" Safety Management ")]), _c('v-tab', [_vm._v(" Security Management ")]), _c('v-tab', [_vm._v(" Quality Control ")]), _c('v-tab', [_vm._v(" Smart Factory ")])], 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('v-row', {
    staticClass: "row--large flex-column-reverse flex-xl-row"
  }, [_c('v-col', {
    staticClass: "mt-20 mt-lg-40 mt-xl-0",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 w-100 border-bottom d-flex flex-column justify-center s2-item"
  }, [_c('h3', {
    staticClass: "poppins tit--lg font-weight-semibold mb-12 mb-lg-24"
  }, [_vm._v("SAFETY MANAGEMENT")]), _c('p', {
    staticClass: "color-point line-height-1 font-size-16 font-size-lg-22 font-weight-semibold mb-22 mb-lg-44"
  }, [_vm._v("안전관리")]), _c('p', {
    staticClass: "tit-txt color-gery-51"
  }, [_vm._v(" 작업자 안전을 위한 산업 보건 및 안전 관리 경영시스템을 구축 "), _c('br'), _vm._v(" 산업안전보건법에 따라 주기적으로 자사 안전 관리 및 점검 실시 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/wwd-img1.png",
      "alt": ""
    }
  })])], 1)], 1), _c('v-tab-item', [_c('v-row', {
    staticClass: "row--large flex-column-reverse flex-xl-row"
  }, [_c('v-col', {
    staticClass: "mt-20 mt-lg-40 mt-xl-0",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 w-100 border-bottom d-flex flex-column justify-center s2-item"
  }, [_c('h3', {
    staticClass: "poppins tit--lg font-weight-semibold mb-12 mb-lg-24"
  }, [_vm._v("SECURITY MANAGEMENT")]), _c('p', {
    staticClass: "color-point line-height-1 font-size-16 font-size-lg-22 font-weight-semibold mb-22 mb-lg-44"
  }, [_vm._v("보안 관리")]), _c('p', {
    staticClass: "tit-txt color-gery-51"
  }, [_vm._v(" 고객의 정보를 안전하게 보호하기 위해, 전 직원 데이터보안 프로그램을 사용하고 "), _c('br', {
    staticClass: "main-s2-pc"
  }), _vm._v(" 있으며 ISO 27001: 2013 정보보호 관리체계 인증 획득 및 시스템 적용을 통해 "), _c('br', {
    staticClass: "main-s2-pc"
  }), _vm._v(" 최우선 순위로 보호 및 통제 중 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/wwd-img2.png",
      "alt": ""
    }
  })])], 1)], 1), _c('v-tab-item', [_c('v-row', {
    staticClass: "row--large flex-column-reverse flex-xl-row"
  }, [_c('v-col', {
    staticClass: "mt-20 mt-lg-40 mt-xl-0",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 w-100 border-bottom d-flex flex-column justify-center s2-item"
  }, [_c('h3', {
    staticClass: "poppins tit--lg font-weight-semibold mb-12 mb-lg-24"
  }, [_vm._v("QUALITY CONTROL")]), _c('p', {
    staticClass: "color-point line-height-1 font-size-16 font-size-lg-22 font-weight-semibold mb-22 mb-lg-44"
  }, [_vm._v("품질관리")]), _c('p', {
    staticClass: "tit-txt color-gery-51"
  }, [_vm._v(" ISO 9001에 따른 체계적이고 효율적인 품질관리 시스템 운영 "), _c('br'), _vm._v(" SPC를 활용한 주기적인 트렌드 분석 및 안정적인 품질 확보 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/wwd-img3.png",
      "alt": ""
    }
  })])], 1)], 1), _c('v-tab-item', [_c('v-row', {
    staticClass: "row--large flex-column-reverse flex-xl-row"
  }, [_c('v-col', {
    staticClass: "mt-20 mt-lg-40 mt-xl-0",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 w-100 border-bottom d-flex flex-column justify-center s2-item"
  }, [_c('h3', {
    staticClass: "poppins tit--lg font-weight-semibold mb-12 mb-lg-24"
  }, [_vm._v("SMART FACTORY")]), _c('p', {
    staticClass: "color-point line-height-1 font-size-16 font-size-lg-22 font-weight-semibold mb-22 mb-lg-44"
  }, [_vm._v("스마트 공장")]), _c('p', {
    staticClass: "tit-txt color-gery-51"
  }, [_vm._v(" 생산과정에 디지털 자동화 솔루션이 결합된 정보통신기술 (ICT)를 적용하여 "), _c('br', {
    staticClass: "main-s2-pc"
  }), _vm._v(" loT를 통해 공정 데이터를 실시간 수집하고 스스로 분석하는 공정 도입 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/wwd-img4.png",
      "alt": ""
    }
  })])], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "main-section main-section3 poppins"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('a', {
    staticClass: "s3-item s3-item1 w-100 arrow-button-wrap",
    attrs: {
      "href": "/about/histroy"
    }
  }, [_c('span', {
    staticClass: "line line1"
  }), _c('span', {
    staticClass: "line line2"
  }), _c('span', {
    staticClass: "line line3"
  }), _c('span', {
    staticClass: "line line4"
  }), _c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/quick-img1.png",
      "alt": ""
    }
  }), _c('h6', {
    staticClass: "font-weight-semibold font-size-18 font-size-lg-28 w-100"
  }, [_vm._v("Company History")]), _c('button', {
    staticClass: "arrow-button sm round point-light"
  }, [_c('img', {
    staticClass: "d-block",
    attrs: {
      "src": "/images/common/arrow-w.svg",
      "alt": ""
    }
  })])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('a', {
    staticClass: "s3-item s3-item2 w-100 arrow-button-wrap",
    attrs: {
      "href": "/about/partner"
    }
  }, [_c('span', {
    staticClass: "line line1"
  }), _c('span', {
    staticClass: "line line2"
  }), _c('span', {
    staticClass: "line line3"
  }), _c('span', {
    staticClass: "line line4"
  }), _c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/quick-img2.png",
      "alt": ""
    }
  }), _c('h6', {
    staticClass: "font-weight-semibold font-size-18 font-size-lg-28 w-100"
  }, [_vm._v("Partners")]), _c('button', {
    staticClass: "arrow-button sm round point-light"
  }, [_c('img', {
    staticClass: "d-block",
    attrs: {
      "src": "/images/common/arrow-w.svg",
      "alt": ""
    }
  })])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('a', {
    staticClass: "s3-item s3-item3 w-100 arrow-button-wrap",
    attrs: {
      "href": "/about/status"
    }
  }, [_c('span', {
    staticClass: "line line1"
  }), _c('span', {
    staticClass: "line line2"
  }), _c('span', {
    staticClass: "line line3"
  }), _c('span', {
    staticClass: "line line4"
  }), _c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/main/quick-img3.png",
      "alt": ""
    }
  }), _c('h6', {
    staticClass: "font-weight-semibold font-size-18 font-size-lg-28 w-100"
  }, [_vm._v("Certification Status")]), _c('button', {
    staticClass: "arrow-button sm round point-light"
  }, [_c('img', {
    staticClass: "d-block",
    attrs: {
      "src": "/images/common/arrow-w.svg",
      "alt": ""
    }
  })])])])], 1)], 1), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }